 /*******************系统管理*******************/
 const qykf = resolve => require(['@/pages/customservice/qykf'], resolve);

 export default [
   //七鱼客服
   {
     path: "/qykf",
     name: "七鱼客服",
     component: qykf
   }
 ]
